import React, {
  ComponentType
} from 'react'
import {
  Icon,
  Popup,
  Segment
} from 'semantic-ui-react'
// Local
import { PATIENT_RULES } from '../../../constant'
import { expandSpecialtyFilter } from '../../common/ruleFilterUtils'
import { cdiRuleFilterAndRuleRiskCategoryVersionEnabled } from '../../common/currentUserUtils'
import { Patient } from '../../patient/patient'
import { User } from '../../authenticated/types'

const SafeSegment = Segment as unknown as ComponentType<any>
const SafePopup = Popup as unknown as ComponentType<any>
const SafeIcon = Icon as unknown as ComponentType<any>

type PatientRuleFiltersProps = {
  patient: Patient | undefined
  currentUser: User
  mode?: string
}

/**
 * Provides a component that renders the patient rule filters, if provided
 *
 * @param patient Patient entity
 * @param mode Render mode. Default: left
 */
function PatientRuleFilters(
  props: PatientRuleFiltersProps
): JSX.Element | null {
  const {
    patient,
    currentUser,
    mode: modeProp
  } = props

  const mode = modeProp || 'left'

  const getPopupMessage = (expanded: string): string => (
    `Only ${expanded} conditions will present to the Provider for this encounter`
  )

  const displayFilters = (filters: string): JSX.Element => {
    const tokens = filters.split(',')
    const lastFilter = tokens.slice(-1)[0]
    const fullSpecialty = expandSpecialtyFilter(lastFilter)
    const spanId = 'patient-filter-span'

    if (fullSpecialty === '') {
      // did not match to a specialty
      return (
        <span id={ spanId }>{ tokens.join(', ') }</span>
      )
    }

    const updatedTokens = [ ...tokens ]
    updatedTokens.pop()
    updatedTokens.push(fullSpecialty)

    return (
      <span id={ spanId }>
        { updatedTokens.join(', ').toUpperCase() }
        <SafePopup
          content={ getPopupMessage(fullSpecialty) }
          mouseEnterDelay={ 500 }
          trigger={
            <span id="patient-filter-span-icon">
              &nbsp;
              <SafeIcon
                id="patient-filter-icon"
                name="info circle"
                className="pointer"
              />
            </span>
          }
        />
      </span>
    )
  }

  const renderLeft = (
    patientData: Patient | undefined,
    user: User
  ): JSX.Element | null => {
    if (!cdiRuleFilterAndRuleRiskCategoryVersionEnabled(user)) {
      return null
    }
    if (patientData && patientData.rulesFilterTypes) {
      const filters = patientData.rulesFilterTypes
      const isCuration3 = filters.toUpperCase().includes('DYN')
      return (
        <SafeSegment
          attached
          compact
          className="left-segment"
        >
          <div className="left-title">Patient Rule Filters:</div>
          <div className="left-content">
            <div>{ displayFilters(filters) }</div>
            { isCuration3 && (
              <div>
                <span className="italic">Curation 3.0</span>
              </div>
            ) }
          </div>
        </SafeSegment>
      )
    }
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <div className="left-title">Patient Rule Filters:</div>
        <div className="left-content">
          <div>{ PATIENT_RULES.PATIENT_RULES_FILTERS }</div>
        </div>
      </SafeSegment>
    )
  }

  if (mode === 'left') {
    return renderLeft(patient, currentUser)
  }
  return null
}

export default PatientRuleFilters
